(function ($, Drupal, once) {

    /* Logic to switch between tabs for content displayed on a single page */
    Drupal.behaviors.mitosNavigation = {

        attach: function (context, settings) {

          if ($(".dropdown.menu > li.has-submenu .featured-item__container").length) {

            $(once('mitosNavigation','.dropdown.menu > li.has-submenu', context)).each(function(index) {
              let menuImage = $(this).children('.featured-item__container').detach();
              let submenuImageContainer = $(this).find('ul .submenu-container');
              menuImage.appendTo(submenuImageContainer);
            });
          }

          if ($(".vertical.menu > li.has-submenu .featured-item__container").length) {

            $(once('mitosNavigation','.vertical.menu > li.has-submenu', context)).each(function(index) {
              let menuImage = $(this).children('.featured-item__container').detach();
              let submenuImageContainer = $(this).find('ul.submenu-1');
              menuImage.appendTo(submenuImageContainer);
            });
          }

          if ($('.menu >.has-submenu.menu-item--active-trail .submenu-1 >li').length) {
              let isOverview = true;

            $(once('mitosNavigationOverview','.menu >.menu-item--active-trail .submenu-1 >li', context)).each(function(index) {
              if($(this).hasClass('menu-item--active-trail')) {
                isOverview = false;
              }
            });

            if(isOverview === true) {
              $('.menu >.has-submenu.menu-item--active-trail .submenu-1 .submenu-container >li:first-child').addClass('menu-item--active-trail')
              $('.gp-content__container .dropdown.menu li').first().remove();
            }




          }

          if ($(".submenu-1").length) {

            let isOverview = '';


              $(document).on("show.zf.dropdownMenu", function() {

                $(once('mitosNavigation','.submenu-1 li.has-submenu', context)).each(function(index) {
                  $(this).removeClass('is-dropdown-submenu-parent')
                });

              });

              // hide all but the first submenu when the dropdown opens

            $(document).on("opened.zf.offCanvas", function() {
              $(once('mitosNavigation','.mobile-navigation nav.menu--main .menu.vertical:not(.submenu) > li .submenu.is-active', context)).each(function(index) {
                $(this).hide().removeClass('is-active');
              });
            });

            $(document).on("closed.zf.offCanvas", function() {
              $(once('mitosNavigation','.mobile-navigation nav.menu--main .menu.vertical:not(.submenu) > li:not(:first-child) .submenu.is-active', context)).each(function(index) {
                $(this).hide().removeClass('is-active');
              });
              $(once('mitosNavigation','.mobile-navigation nav.menu--main .menu.vertical .submenu-1', context)).each(function(index) {
                $(this).show().addClass('is-active');
              });
              $(once('mitosNavigation','.mobile-navigation nav.menu--main .menu.vertical .submenu-1', context)).each(function(index) {
                $(this).show().addClass('is-active');
              });
            });
          }

        }
    };
}(jQuery, Drupal, once));
